import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { FormModal } from '../../Form'

import {
  NEWSBOARD_POST_PROFILE_EDIT_TIME_RANGE_MODAL_QA_NAME,
  NEWSBOARD_POST_PROFILE_EDIT_TIME_RANGE_MODAL_SUBMIT_QA_NAME,
} from './NewsboardPostProfileEditTimeRangeModal.constants'
import { NewsboardPostProfileEditTimeRangeModalFields } from './NewsboardPostProfileEditTimeRangeModalFields'

function NewsboardPostProfileEditTimeRangeModal({
  Fields = NewsboardPostProfileEditTimeRangeModalFields,
  ...restProps
}) {
  return (
    <FormModal
      {...restProps}
      Fields={Fields}
      containerProps={{
        qaName: NEWSBOARD_POST_PROFILE_EDIT_TIME_RANGE_MODAL_QA_NAME,
      }}
      formBodyProps={{
        ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
        submitQaName:
          NEWSBOARD_POST_PROFILE_EDIT_TIME_RANGE_MODAL_SUBMIT_QA_NAME,
      }}
      formTitle='NewsboardPostProfile.EditTimeRangeModalTitleKey'
    />
  )
}

export default NewsboardPostProfileEditTimeRangeModal
